class RedemptionDiscount {
    constructor(redemptionList) {
        this.redemptionList = redemptionList;
    }

    renderRedemptionList() {
        this.redemptionList.forEach(redemption => {
            if (redemption.discountType == "fixed_amount") {
                $(".redemption-container").append(
                    $("<div>").append(
                        $('<p>').text(`${redemption.name}`).addClass("redemption-title"),
                        $('<p>').text(`${redemption.costText}`).addClass("redemption--title-text")

                    ).attr({
                        "class": "redemption-text"
                    })
                )
            }
        })

    }

}